import { Enums } from '../common/enums'
import { DataType } from '../../helpers/common-helper'
import { Utils } from '../util/utils'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

import { OpChartSeriesPoint } from './op-chart-series-point'
import { OpDescr } from '../core/op-descr'
import { OpDashboardControl } from './op-dashboard-control'
import { OpDashboardGroup } from './op-dashboard-group'
import { OpEnumObject } from './op-enum-object'
import { OpFile } from '../core/op-file'


export class OpGridRow {
    //Properties
    public key: any
    public values: Dictionary<any>
    //Properties end

    //NavigationProperties
    //NavigationProperties end

    constructor(opObj: any) {
        if (opObj) {
            this.key = opObj.Key
            this.values = null//TO DO konwersja z System.Collections.Generic.Dictionary
        }
        if (!this.values)
            this.values = new Dictionary(null)
    }
}